<template>
    <v-container grid-list-sm class="pa-4">
        <v-layout row wrap>
            <v-flex xs4>
            {{description}}
            </v-flex>
            <v-flex xs4 justify-center>
                &euro; {{price}}:
            </v-flex>
            <v-flex xs4 align-end>
                <v-btn fab dark small color="primary" @click="subtract">
                    <v-icon dark>remove</v-icon>
                </v-btn>
                <input v-model="count" style="display: inline; width: 30px; text-align: center;" type="number"/>
                <v-btn fab dark small color="primary" @click="add">
                    <v-icon dark>add</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: "PriceSelection",
  props: {
    value: Number,
    description: String,
    price: Number
  },
  computed: {
    count: {
      get() {
        return Number(this.value);
      },
      set(v) {
        this.$emit("input", Number(v));
      }
    }
  },
  methods: {
    add() {
      this.count = Number(this.count) + 1;
    },
    subtract() {
      this.count = Number(this.count) - 1 < 0 ? 0 : Number(this.count) - 1;
    }
  }
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
</style>
